export const errorMessage = (error) => {
  if(error.response && error.response.status===422 && error.response.data.errors.length > 0){
    alert(error.response.data.errors.join("\n"))
  } else if(error.response && error.response.status===401){
    alert(error.response.data.error)
  } else {
    alert(error)
  }
}
